import { S3_BUCKET_URL } from '@/constants';
import { webCampaign } from '@/modules/webCampaign';

export const useWelcomeBackgroundImage = (): string => {
  const layoutNotes = webCampaign.getLayoutNotes();

  const backgroundImageNote = layoutNotes.find((note) =>
    ['bretty1', 'bretty3', 'olivia2', 'xinhua1'].includes(note),
  );

  if (backgroundImageNote) {
    return `${S3_BUCKET_URL}/layout-own-ai/welcome-v2/${backgroundImageNote}.png`;
  }

  return `${S3_BUCKET_URL}/layout-own-ai/welcome/breatty1.png`;
};
